<template>
  <v-snackbar
    v-model="notification.snackbar"
    class="app-notification"
    :color="notification.color"
    location="top right"
    close-on-content-click
    @update:model-value="reset($event)"
  >
    <template #text>
      <div class="app-notification__text text-caption">
        {{ notification.text }}
      </div>
    </template>
  </v-snackbar>
</template>

<script lang="ts" setup>
  import { useNotificationStore } from '@/store/notification'

  const notification = useNotificationStore()

  const reset = (value: boolean) => {
    if (value === false) {
      notification.reset()
    }
  }
</script>
